<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div>
    <div class="comment" ref="comWrapper">
      <div
        class="cover"
        v-show="chooseFlag"
        @click="chooseFlag = false"
        @touchmove.prevent
      ></div>
      <list
        class="pc-custom-list"
        style="height: 800px; overflow: hidden"
        v-bind="$data"
        defaultText="还没有任何评论，赶快发布吧"
        @click.native="clickList"
        :listData="forEachList"
      >
        <ul
          ref="listScroll"
          id="ulBox"
          class="ulBox"
          @scroll="preLoad"
          v-if="forEachList.length"
        >
          <template v-for="(item, index) in forEachList">
            <div class="disable-item" :key="index" v-if="item.isDisableUser">
              <div class="content">
                <img
                  :src="
                    item.enable
                      ? require('@/assets/v-1.jpg')
                      : require('@/assets/v-2.jpg')
                  "
                  alt
                />
                {{ item.nickName }}已被{{ item.enable ? '解除' : '' }}禁言
              </div>
            </div>
            <div class="item" :key="index" v-else>
              <div class="header">
                <div class="left">
                  <div class="header-img">
                    <img :src="item.headPhoto || blankHeaderImg" />
                  </div>
                  <div class="name" :class="{ admin: isAdminComment(item) }">
                    {{ item.fullName }}
                  </div>
                  <div class="top" v-if="item.isTop == 1">顶</div>
                  <div class="admin-tag" v-if="isAdminComment(item)">
                    {{ item.rank }}
                  </div>
                </div>
                <div class="right">{{ item.createDt | transTime }}</div>
              </div>
              <div class="content">
                <div class="text">
                  <template v-if="item.replyUserNickName">
                    <span>回复</span>
                    <span class="blue-text">@{{ item.replyUserNickName }}</span>
                    <span>：</span>
                  </template>
                  <span v-if="item.msgType == 3">
                    <!-- 层级问题，所以使用alert打开图片预览 -->
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.commentContent"
                      @click="handlePictureCardPreview(item.commentContent)"
                    ></el-image>
                  </span>
                  <span v-else>{{ item.commentContent }}</span>
                </div>
              </div>
              <div class="link-comment" v-if="item.replyUserNickName">
                <span class="blue-text">@{{ item.replyUserNickName }}</span>
                <span>：</span>
                <span>{{ item.replyContent }}</span>
              </div>
            </div>
          </template>
        </ul>
      </list>
    </div>
    <div class="footer">
      <div class="footer-input">
        <textarea
          type="text"
          ref="replyInput"
          :placeholder="placeholder"
          v-model.trim="replyValue"
          @keyup.enter="sendReply"
          @focus="onFocus"
          @blur="onBlur"
        />
      </div>
      <ul
        class="comment__living"
        v-show="!focus && !replyValue.length && type == 3"
      >
        <li>
          <img
            style="width: 30px; height: 30px"
            src="@/static/img/living/liwu.png"
            alt
            @click.stop="showGift = true"
          />
        </li>
      </ul>
      <van-button
        class="send"
        style="width: 60px; height: 36px"
        v-show="focus || replyValue.length"
        :disabled="replyValue.length < 2"
        type="primary"
        @click="sendReply"
        color="#3667EC"
      >
        发送
      </van-button>
      <emoji
        v-model="isOpenEmoji"
        @sendFatherEmoji="getEmoji"
        @deleteFatherEmoji="deleteEmoji"
      ></emoji>
      <send-gift
        class="pc-custom-gift"
        v-model="showGift"
        @send="sendGif"
      ></send-gift>
    </div>
  </div>
</template>
<script>
import index from '../comment/comment';
export default {
  name: 'pc-comment-list',
  mixins: [index],
  methods: {
    onBlur() {
      this.onFocus();
      this.focus = false;
      if (this.type > 2) {
        // 个别手机第三方输入法弹出、消失较慢
        setTimeout(function() {
          document.getElementById('ulBox').scrollTop = 0;
        }, 200);
      }
    },
    handlePictureCardPreview(url) {
      this.$alert(<img src={url} style={{ width: '100%' }} />, '', {
        showConfirmButton: false,
        customClass: 'img-pc-dialog'
      });
    }
  },
  created() {
    document.body.addEventListener('click', this.clickList);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.clickList);
  }
};
</script>
<style lang="scss" scoped>
@import './comment.scss';
</style>
<style lang="scss">
.pc-custom-list {
  .missBox {
    img {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      color: #959599;
      line-height: 1.2;
    }
  }
}
.gift.pc-custom-gift {
  width: 100% !important;
  position: absolute !important;
  bottom: 66px !important;
  padding: 10px !important;
  .gift__item {
    width: 100%;
    height: auto;
    cursor: pointer;
    div {
      margin-bottom: 10px;
      img {
        width: 40px;
        height: 40px;
        margin-bottom: 5px;
      }
      p {
        font-size: 14px;
      }
    }
    & > p {
      padding: 5px 0;
    }
  }
}
</style>
